<template>
    <div class="navbar-home-dropdown" v-bind:class="{ 'dropdown-open': navbarDropdown === true }">
        <button v-on:click="navbarSetDropdown(!navbarDropdown)" class="button-toggle">
            <div class="button-inner">
                <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.1224 3.00476C16.3487 -1.5523 12.1703 1.6181 12.1703 1.6181C11.8994 1.8229 11.3997 1.99129 11.0602 1.99208L9.94096 1.99286C9.60145 1.99325 9.10176 1.82486 8.83117 1.62006C8.83117 1.62006 4.65239 -1.55113 1.87829 3.00593C-0.89503 7.56143 0.2226 12.5226 0.2226 12.5226C0.4184 13.7374 1.06376 14.548 2.28164 14.4462C3.49599 14.3447 6.13186 11.1747 6.13186 11.1747C6.34959 10.9135 6.80581 10.7001 7.14454 10.7001L13.8542 10.6989C14.1934 10.6989 14.6492 10.9124 14.8665 11.1736C14.8665 11.1736 17.5028 14.3436 18.7191 14.445C19.9354 14.5468 20.5823 13.7354 20.777 12.5214C20.777 12.5214 21.8962 7.56104 19.1224 3.00476ZM7.97865 6.714H6.53991V8.10066C6.53991 8.10066 6.23524 8.33327 5.76376 8.3274C5.29305 8.32035 5.08002 8.07364 5.08002 8.07364V6.71439H3.72116C3.72116 6.71439 3.5516 6.54052 3.50617 6.08274C3.46153 5.62496 3.69375 5.2549 3.69375 5.2549H5.13289V3.81615C5.13289 3.81615 5.42894 3.65756 5.85461 3.6697C6.28067 3.68301 6.59277 3.84318 6.59277 3.84318L6.5869 5.25451H7.94576C7.94576 5.25451 8.18307 5.55917 8.20265 5.92728C8.22223 6.29577 7.97865 6.714 7.97865 6.714ZM14.5779 8.2945C13.9478 8.2945 13.4399 7.78503 13.4399 7.15573C13.4399 6.52525 13.9478 6.01695 14.5779 6.01695C15.2053 6.01695 15.7171 6.52525 15.7171 7.15573C15.7171 7.78542 15.2053 8.2945 14.5779 8.2945ZM14.5779 5.1613C13.9478 5.1613 13.4399 4.65222 13.4399 4.02292C13.4399 3.39244 13.9478 2.88414 14.5779 2.88414C15.2053 2.88414 15.7171 3.39244 15.7171 4.02292C15.7171 4.65261 15.2053 5.1613 14.5779 5.1613ZM17.4139 6.84323C16.7838 6.84323 16.2759 6.33415 16.2759 5.70446C16.2759 5.07437 16.7838 4.56568 17.4139 4.56568C18.0412 4.56568 18.5531 5.07437 18.5531 5.70446C18.5531 6.33415 18.0412 6.84323 17.4139 6.84323Z" />
                </svg>
                GAMES
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5176 1.66411e-06L0.482354 8.43375e-08C0.0547936 9.58042e-09 -0.16302 0.516304 0.143533 0.822859L4.66115 5.34052C4.8467 5.52607 5.15325 5.52607 5.33888 5.34052L9.8565 0.822861C10.163 0.516306 9.94516 1.73887e-06 9.5176 1.66411e-06Z" />
                </svg>
            </div>
        </button>
        <div class="dropdown-menu">
            <div class="menu-inner">
                <router-link v-on:click.native="navbarSetDropdown(false)" to="/battles">
                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.85167 8.41955L6.81332 11.2805L5.62916 12.4246L6.815 13.5695L5.63 14.7136L3.55583 12.711L1.185 15L0 13.8559L2.37084 11.5662L0.296669 9.56443L1.48167 8.42036L2.66667 9.56362L3.85167 8.41955ZM0.457574 0L3.42929 0.00242733L13.3325 9.56443L14.5183 8.42036L15.7033 9.56443L13.63 11.567L16 13.8559L14.815 15L12.4442 12.711L10.37 14.7136L9.185 13.5695L10.37 12.4246L0.460088 2.85695L0.457574 0ZM12.5732 0L15.5424 0.00242733L15.5441 2.8529L12.1475 6.1314L9.18416 3.27121L12.5732 0Z" />
                    </svg>
                    <span class="text-green-gradient-exact">Battles</span>
                </router-link>
                <router-link v-on:click.native="navbarSetDropdown(false)" to="/unbox">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.98114 15.5613L2.04173 12.5916C1.86593 12.5037 1.75491 12.324 1.75491 12.1275V9.45755L4.57473 10.8675C5.08598 11.1231 5.68772 11.1231 6.19898 10.8675L6.23978 10.8471L7.98111 9.77582L7.98114 15.5613ZM9.01883 15.5613V9.77578L10.7602 10.847L10.801 10.8674C11.3122 11.1231 11.914 11.1231 12.4252 10.8674L15.245 9.45752V12.1275C15.245 12.324 15.134 12.5036 14.9582 12.5915L9.01883 15.5613ZM1.63244 5.12301L0.430391 4.522C0.0459475 4.32977 -0.10989 3.8623 0.0823311 3.47785C0.157641 3.32723 0.27977 3.2051 0.430391 3.12979L5.03879 0.825609C5.2579 0.716054 5.5158 0.716054 5.73488 0.825609L8.05056 1.98345C7.88633 2.01987 7.72545 2.07652 7.57178 2.15337L1.63244 5.12301ZM8.94934 1.98342L11.265 0.825574C11.4841 0.71602 11.742 0.71602 11.9611 0.825574L16.5695 3.12976C16.7201 3.20507 16.8423 3.3272 16.9176 3.47782C17.1098 3.86226 16.954 4.32974 16.5695 4.52196L15.3675 5.12297L9.42809 2.15327C9.27442 2.07649 9.11357 2.01984 8.94934 1.98342ZM5.73494 9.93928C5.51584 10.0488 5.25794 10.0488 5.03886 9.93928L0.430423 7.63509C0.279803 7.55978 0.157674 7.43766 0.0823638 7.28704C-0.109858 6.90259 0.0459467 6.43512 0.430423 6.24286L1.63248 5.64185L7.74912 8.70017L5.73494 9.93928ZM16.5695 6.24286C16.954 6.43508 17.1098 6.90256 16.9176 7.28704C16.8423 7.43766 16.7202 7.55978 16.5695 7.63509L11.9611 9.93928C11.742 10.0488 11.4841 10.0488 11.2651 9.93928L9.25088 8.70017L15.3675 5.64185L16.5695 6.24286ZM13.566 5.38244L8.49999 7.91544L3.43397 5.38244L8.03592 3.08147C8.32806 2.9354 8.67191 2.9354 8.96409 3.08147L13.566 5.38244Z" />
                    </svg>
                    <span class="text-green-gradient-exact">Cases</span>
                </router-link>

                </router-link>
        
                </router-link>
                <router-link v-on:click.native="navbarSetDropdown(false)" to="/mines">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.469 3.32317C13.3233 3.61196 13.0761 3.82791 12.7717 3.92938C12.4647 4.03085 12.1395 4.00743 11.8507 3.86173L10.3417 3.10722C10.2142 3.04218 10.0685 3.03437 9.93322 3.08121C9.79793 3.12544 9.69126 3.2191 9.62621 3.34658L9.43368 3.73425L8.83008 3.43244L9.02261 3.04999C9.16831 2.76119 9.41287 2.54525 9.71988 2.44378C10.0269 2.34231 10.3521 2.36572 10.6383 2.50882L12.1499 3.26593C12.2774 3.32577 12.4179 3.33878 12.5532 3.29195C12.6885 3.24772 12.7977 3.15406 12.8628 3.02657C12.9434 2.86266 13.149 2.78981 13.3129 2.87567C13.482 2.95632 13.5497 3.15666 13.469 3.32317Z" />
                        <path d="M7.90897 4.73864C7.948 4.75425 7.98702 4.76986 8.02605 4.78547C8.16394 4.84271 8.30183 4.90255 8.43973 4.9702C8.63746 5.06906 8.82219 5.17834 9.00431 5.29281C9.05374 5.32403 9.10057 5.35525 9.1474 5.38648C9.19944 5.4203 9.25408 5.45412 9.30611 5.49055L9.44921 5.20175C9.60531 4.88694 9.47783 4.50188 9.16301 4.34838L8.50477 4.01795C8.35387 3.9425 8.17955 3.9295 8.01824 3.98413C7.85694 4.03877 7.72685 4.15064 7.6514 4.30415L7.5083 4.59554C7.52911 4.60335 7.55253 4.61115 7.57334 4.61896C7.68522 4.65278 7.7971 4.69441 7.90897 4.73864Z" />
                        <path d="M9.20995 6.2685C9.20735 6.26589 9.20735 6.26589 9.20995 6.2685C9.05125 6.13581 8.88213 6.01352 8.70261 5.89645C8.52309 5.77937 8.33577 5.67269 8.13803 5.57123C7.75037 5.3787 7.3471 5.233 6.94643 5.13673C6.49893 5.03006 6.05143 4.97803 5.60913 4.97803C3.51732 4.97803 1.56861 6.14621 0.592955 8.09232C-0.793778 10.8632 0.335382 14.2481 3.10885 15.6374C5.88231 17.0241 9.26719 15.8924 10.6539 13.1189C11.8351 10.7643 11.2419 7.94662 9.20995 6.2685ZM2.05254 8.82081C1.52698 9.86932 1.49056 11.0921 1.95107 12.1719C2.02392 12.3436 1.94326 12.5413 1.77415 12.6142C1.72992 12.6324 1.68569 12.6402 1.64146 12.6402C1.51137 12.6402 1.38649 12.5621 1.33185 12.4346C0.79329 11.1728 0.83752 9.74443 1.45153 8.51901C1.53479 8.3525 1.73773 8.28485 1.90424 8.36811C2.06815 8.45136 2.13579 8.6543 2.05254 8.82081Z" />
                        <path d="M3.83992 14.175C3.39503 13.9539 3.00216 13.6573 2.67174 13.293C2.54685 13.1551 2.33351 13.1447 2.19562 13.2696C2.05773 13.3945 2.04732 13.6078 2.1722 13.7457C2.55986 14.1698 3.01777 14.5185 3.53552 14.776C3.58495 14.7994 3.63439 14.8125 3.68642 14.8125C3.8087 14.8125 3.92838 14.7448 3.98822 14.6277C4.07148 14.4612 4.00383 14.2583 3.83992 14.175Z" />
                        <path d="M13.0423 0.495126C12.8575 0.469109 12.6858 0.593993 12.6572 0.776115L12.5167 1.68413C12.4881 1.86885 12.6156 2.04057 12.7977 2.06919C12.8159 2.07179 12.8315 2.07439 12.8497 2.07439C13.0136 2.07439 13.1567 1.95471 13.1828 1.7882L13.3233 0.880185C13.3519 0.695461 13.2244 0.523745 13.0423 0.495126Z" />
                        <path d="M14.7128 1.23925C14.5619 1.12997 14.3511 1.1664 14.2445 1.3173L13.7215 2.05359C13.6148 2.2045 13.6487 2.41524 13.7996 2.52191C13.8594 2.56354 13.9271 2.58435 13.9947 2.58435C14.0988 2.58435 14.2028 2.53492 14.2679 2.44386L14.7908 1.70756C14.8975 1.55666 14.8637 1.34852 14.7128 1.23925Z" />
                        <path d="M15.9614 2.57377C15.8756 2.40986 15.67 2.34742 15.5061 2.43328L14.6944 2.86257C14.5305 2.94842 14.468 3.15396 14.5539 3.31787C14.6137 3.43235 14.7308 3.49739 14.8531 3.49739C14.9051 3.49739 14.9598 3.48438 15.0092 3.45837L15.8209 3.02908C15.9848 2.94062 16.0473 2.73768 15.9614 2.57377Z" />
                    </svg>
                    <span class="text-green-gradient-exact">Mines</span>
                </router-link>
                <router-link v-on:click.native="navbarSetDropdown(false)" to="/towers">
                    <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.7526 0H8.72751C8.59087 0 8.48009 0.110779 8.48009 0.247413V1.48448H6.82861V0.247413C6.82861 0.110779 6.71783 0 6.5812 0H4.41757C4.28093 0 4.17015 0.110779 4.17015 0.247413V1.48448H2.51991V0.247413C2.51991 0.110779 2.40913 0 2.27249 0H0.247413C0.110779 0 0 0.110779 0 0.247413V2.9034C0.00136077 3.57305 0.543908 4.1156 1.21356 4.11696H1.21851H9.78644C10.4561 4.1156 10.9986 3.57305 11 2.9034V0.247413C11 0.110779 10.8892 0 10.7526 0Z" />
                        <path d="M9.58606 4.48682H1.42141L1.07132 12.43V12.5067C1.06894 12.8843 1.19648 13.2512 1.43255 13.5459C1.64925 13.8246 1.97469 13.9974 2.32694 14.0209H8.68176C9.03401 13.9974 9.35946 13.8246 9.57616 13.5459C9.81222 13.2512 9.93976 12.8843 9.93738 12.5067C9.93738 12.4919 9.93738 12.4659 9.93738 12.43L9.58606 4.48682ZM7.38036 13.5384H3.62463V10.0549C3.62463 9.01671 4.4662 8.17513 5.50435 8.17513C6.5425 8.17513 7.38408 9.01671 7.38408 10.0549L7.38036 13.5384Z" />
                    </svg>
                    <span class="text-green-gradient-exact">Towers</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NavbarHomeDropdown',
        data() {
            return {
                navbarDropdown: false
            }
        },
        methods: {
            navbarSetDropdown(value) {
                this.navbarDropdown = value;
            }
        },
        created() {
            let self = this;
            document.addEventListener('click', function(event) {
                if(!self.$el.contains(event.target) && self.navbarDropdown === true) {
                    self.navbarSetDropdown(false);
                }
            });
        }
    }
</script>

<style scoped>
    .navbar-home-dropdown {
        position: relative;
    }

    .navbar-home-dropdown button.button-toggle {
        width: 140px;
        height: 50px;
        position: relative;
        padding: 1px;
        filter: drop-shadow(0px 4px 25px rgba(59, 126, 183, 0.38));
        z-index: 2;
    }

    .navbar-home-dropdown button.button-toggle::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(0, 133, 255, 0) 0%, #328adb 100%);
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    .navbar-home-dropdown button.button-toggle::after {
        content: '';
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        background: #061628;
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    .navbar-home-dropdown button.button-toggle .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: 800;
        color: #6e95b6;
        background: linear-gradient(255deg, rgba(59, 126, 183, 0.5) -70%, rgba(20, 80, 129, 0.5) 90%);
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        transition: all 0.3s ease;
    }

    .navbar-home-dropdown.dropdown-open button.button-toggle .button-inner,
    .navbar-home-dropdown button.button-toggle:hover .button-inner {
        color: #ffffff;
        background: linear-gradient(255deg, #3b7eb7 -70%, #145081 90%);
    }

    .navbar-home-dropdown button.button-toggle .button-inner svg:first-of-type {
        margin-right: 8px;
        fill: #6e95b6;
        transition: fill 0.5s ease;
    }

    .navbar-home-dropdown button.button-toggle .button-inner svg:last-of-type {
        width: 10px;
        margin-left: 8px;
        fill: #6e95b6;
        transition: all 0.3s ease;
    }

    .navbar-home-dropdown.dropdown-open button.button-toggle .button-inner svg,
    .navbar-home-dropdown button.button-toggle:hover .button-inner svg {
        fill: #ffffff;
    }

    .navbar-home-dropdown.dropdown-open button.button-toggle .button-inner svg:last-of-type {
         transform: rotate(180deg);
    }

    .navbar-home-dropdown .dropdown-menu {
        height: 0;
        position: absolute;
        top: 25px;
        left: 50%;
        transform: translate(-50%, 0);
        transition: height 0.2s ease;
        overflow: hidden;
    }

    .navbar-home-dropdown.dropdown-open .dropdown-menu {
       height: 432px;
    }

    .navbar-home-dropdown .menu-inner {
        width: 145px;
        display: flex;
        flex-direction: column;
        padding-top: 40px;
        border-radius: 15px;
        background: radial-gradient(163% 163% at 50% -30%, rgba(49, 114, 168, 0.2) 0%, rgba(0, 0, 0, 0) 100%),
                    linear-gradient(255deg, #07263d 0%, #07243a 100%),
                    linear-gradient(255deg, rgba(59, 126, 183, 0.15) 0%, rgba(20, 80, 129, 0.15) 100%);
    }

    .navbar-home-dropdown .menu-inner a {
        width: 100%;
        height: 49px;
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-size: 14px;
        font-weight: 600;
        color: #bbbfd0;
        border-top: 1px solid rgba(24, 72, 109, 0.5);
        transition: all 0.3s ease;
    }

    .navbar-home-dropdown .menu-inner a:hover {
        color: #ffffff;
    }

    .navbar-home-dropdown .menu-inner a:last-of-type {
        border-radius: 0 0 15px 15px;
    }

    .navbar-home-dropdown .menu-inner a.router-link-exact-active {
        background: linear-gradient(255deg, rgba(0, 255, 194, 0.15) 0%, rgba(0, 170, 109, 0.15) 100%);
    }

    .navbar-home-dropdown .menu-inner a.router-link-exact-active::before {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(255deg, #00ffc2 0%, #00aa6d 100%);
        opacity: 0.35;
    }

    .navbar-home-dropdown .menu-inner a.router-link-exact-active::after {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(255deg, #00ffc2 0%, #00aa6d 100%);
        opacity: 0.35;
    }

    .navbar-home-dropdown .menu-inner a.router-link-exact-active:last-of-type::after {
        height: 0;
    }

    .navbar-home-dropdown .menu-inner a svg {
        margin-right: 8px;
        fill: #bbbfd0;
    }

    .navbar-home-dropdown .menu-inner a.router-link-exact-active svg {
        fill: #01f3b9;
    }
</style>
